import {useEffect, useRef} from "react";

// Establishment-ID của nhà hàng trên dish.co (lấy từ mã nhúng widget)
const DISH_EID = "hydra-ffdc4bbf-04d5-48be-b045-3951310b8384";
const DISH_WIDGET_SRC = "https://reservation.dish.co/widget.js";

let widgetInstanceCounter = 0;

const DishWidget = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // Mỗi lần mount tạo một tagid riêng để tránh xung đột khi có nhiều widget trên cùng trang
        const tagId = `hors-${DISH_EID}-${widgetInstanceCounter++}`;
        container.innerHTML = "";
        const target = document.createElement("div");
        target.id = tagId;
        container.appendChild(target);

        // widget.js đọc cấu hình từ biến toàn cục window._hors khi load
        window._hors = [
            ["eid", DISH_EID],
            ["tagid", tagId],
            ["width", "100%"],
            ["height", ""],
            ["foregroundColor", ""],
            ["backgroundColor", ""],
            ["linkColor", ""],
            ["errorColor", ""],
            ["primaryButtonForegroundColor", ""],
            ["primaryButtonBackgroundColor", ""],
            ["secondaryButtonForegroundColor", ""],
            ["secondaryButtonBackgroundColor", ""],
        ];

        const script = document.createElement("script");
        script.src = DISH_WIDGET_SRC;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            if (container) container.innerHTML = "";
            if (script.parentNode) script.parentNode.removeChild(script);
        };
    }, []);

    return <div className="form-left dish-widget" ref={containerRef}/>;
};

export default DishWidget;
